export function arrayToChunk(array: any[], size: number) {
    var results: any[] = [];
    while (array.length) {
        results.push(array.splice(0, size));
    }

    return results;
}

export function moveItemToNewPosition(array: any[], index: number, position: number): any[] {
    if (!array?.length || index < 0 || index > array?.length) {
        return;
    }

    array.splice(position, 0, array.splice(index, 1)[0]);
    return array;
}

export function removeDuplicateByKey(array: any[], key: string): any[] {
    var newArray = [];
    var lookupObject = {};

    for (var i in array) {
        lookupObject[array[i][key]] = array[i];
    }

    for (i in lookupObject) {
        newArray.push(lookupObject[i]);
    }

    return newArray;
}